const isNumeric = (number: any) => !isNaN(number) && !isNaN(parseFloat(number));

export { isNumeric };
